'use es6';

import { isHubSpotter, isForceOpen, warn } from '../utils';
import translations from '../wootric-translations';
import * as UserAttributes from '../sources/UserAttributes';
const csatTokenQA = 'NPS-3489af5b';
const csatTokenProd = 'NPS-61a7bd63';
const SurveyKeys = {
  ACCOUNTS_AND_BILLING: 'ACCOUNTS_AND_BILLING',
  WORKFLOWS: 'WORKFLOWS',
  INBOX: 'INBOX',
  CMS_CONTENT_DETAIL: 'CMS_CONTENT_DETAIL',
  CMS_DESIGN_MANAGER: 'CMS_DESIGN_MANAGER',
  ADVANCED_BUILDER: 'ADVANCED_BUILDER',
  FORECASTING: 'FORECASTING',
  FORECASTING_SEPG: 'FORECASTING_SEPG',
  SOCIAL: 'SOCIAL',
  MARKETING_EMAIL: 'MARKETING_EMAIL',
  FORMS: 'FORMS',
  CAMPAIGNS: 'CAMPAIGNS',
  INDEX_CRM: 'INDEX_CRM',
  RECORD_CRM: 'RECORD_CRM',
  DEAL: 'DEAL',
  ADS: 'ADS',
  TASKS: 'TASKS',
  SEQUENCES: 'SEQUENCES',
  QUOTES: 'QUOTES',
  ANALYTICS: 'ANALYTICS',
  CHAT: 'CHAT',
  DATA_SYNC: 'DATA_SYNC',
  CRM_LISTS: 'CRM_LISTS',
  CRM_SETTINGS: 'CRM_SETTINGS',
  PAYMENTS: 'PAYMENTS',
  ADMIN_SETUP: 'ADMIN_SETUP',
  IMPORT: 'IMPORT',
  ADMIN_GOVERNANCE: 'ADMIN_GOVERNANCE',
  SINGLE_REPORT_VIEWER: 'SINGLE_REPORT_VIEWER',
  REPORT_LIBRARY: 'REPORT_LIBRARY',
  JOURNEY_ANALYTICS: 'JOURNEY_ANALYTICS',
  SINGLE_OBJECT_BUILDER: 'SINGLE_OBJECT_BUILDER',
  MULTI_TOUCH_ATTRIBUTION: 'MULTI_TOUCH_ATTRIBUTION',
  REPORT_DASHBOARD_VIEW: 'REPORT_DASHBOARD_VIEW',
  PROSPECTING_MEETINGS: 'PROSPECTING_MEETINGS',
  PROSPECTING_MANAGE_SEQUENCES: 'PROSPECTING_MANAGE_SEQUENCES',
  PROSPECTING_TASKS: 'PROSPECTING_TASKS',
  SALES_EXECUTION_DEAL_PIPELINE: 'SALES_EXECUTION_DEAL_PIPELINE',
  SALES_EXECUTION_DEALS: 'SALES_EXECUTION_DEALS'
};
const SurveyConfig = {
  [SurveyKeys.ACCOUNTS_AND_BILLING]: {
    event_name: 'AccountVisit'
  },
  [SurveyKeys.WORKFLOWS]: {
    event_name: 'workflows_visit'
  },
  [SurveyKeys.INBOX]: {
    event_name: 'inbox_visit'
  },
  [SurveyKeys.CMS_CONTENT_DETAIL]: {
    event_name: 'content_pageview'
  },
  [SurveyKeys.CMS_DESIGN_MANAGER]: {
    event_name: 'designmanager_editor'
  },
  [SurveyKeys.ADVANCED_BUILDER]: {
    event_name: 'open_filters'
  },
  [SurveyKeys.FORECASTING]: {
    event_name: 'forecasting_pageview'
  },
  [SurveyKeys.FORECASTING_SEPG]: {
    event_name: 'forecast_pageview'
  },
  [SurveyKeys.SOCIAL]: {
    event_name: 'social_manage'
  },
  [SurveyKeys.MARKETING_EMAIL]: {
    event_name: 'email_pageview'
  },
  [SurveyKeys.FORMS]: {
    event_name: 'form_pageview'
  },
  [SurveyKeys.CAMPAIGNS]: {
    event_name: 'campaigns_details'
  },
  [SurveyKeys.DEAL]: {
    event_name: 'deal_preview'
  },
  [SurveyKeys.ADS]: {
    event_name: 'ads_pageview'
  },
  [SurveyKeys.TASKS]: {
    event_name: 'create_task'
  },
  [SurveyKeys.SEQUENCES]: {
    event_name: 'sequence_pageview'
  },
  [SurveyKeys.QUOTES]: {
    event_name: 'quotes_pageview'
  },
  [SurveyKeys.ANALYTICS]: {
    event_name: 'analytics_nav'
  },
  [SurveyKeys.INDEX_CRM]: {
    event_name: 'open_saved_view'
  },
  [SurveyKeys.RECORD_CRM]: {
    event_name: 'pin_engagement'
  },
  [SurveyKeys.CHAT]: {
    event_name: 'chat_pageview'
  },
  [SurveyKeys.DATA_SYNC]: {
    event_name: 'save_sync'
  },
  [SurveyKeys.CRM_LISTS]: {
    event_name: 'save_list'
  },
  [SurveyKeys.CRM_SETTINGS]: {
    event_name: 'save_property'
  },
  [SurveyKeys.PAYMENTS]: {
    event_name: 'payments_sidebar'
  },
  [SurveyKeys.ADMIN_SETUP]: {
    event_name: 'create_new_user'
  },
  [SurveyKeys.IMPORT]: {
    event_name: 'finish_import'
  },
  [SurveyKeys.ADMIN_GOVERNANCE]: {
    event_name: 'admin_governance'
  },
  [SurveyKeys.SINGLE_REPORT_VIEWER]: {
    event_name: 'single_report_view'
  },
  [SurveyKeys.REPORT_LIBRARY]: {
    event_name: 'report_library_view'
  },
  [SurveyKeys.JOURNEY_ANALYTICS]: {
    event_name: 'journey_builder_pageview'
  },
  [SurveyKeys.SINGLE_OBJECT_BUILDER]: {
    event_name: 'open_single_object_builder'
  },
  [SurveyKeys.MULTI_TOUCH_ATTRIBUTION]: {
    event_name: 'mt_attribution'
  },
  [SurveyKeys.REPORT_DASHBOARD_VIEW]: {
    event_name: 'report_dashboard_view'
  },
  [SurveyKeys.PROSPECTING_MEETINGS]: {
    event_name: 'meeting_usage'
  },
  [SurveyKeys.PROSPECTING_MANAGE_SEQUENCES]: {
    event_name: 'sequence_usage'
  },
  [SurveyKeys.PROSPECTING_TASKS]: {
    event_name: 'start_task_queue'
  },
  [SurveyKeys.SALES_EXECUTION_DEAL_PIPELINE]: {
    event_name: 'dealboard_view'
  },
  [SurveyKeys.SALES_EXECUTION_DEALS]: {
    event_name: 'deal_index_view'
  }
};
export const getConfig = (token, props = {}, surveyKey) => {
  const {
    field_required,
    permission_labels,
    customMessages: overrideMessages,
    complete,
    supported
  } = translations;
  const lang = supported[props.language] ? props.language : 'EN'; // Wootric doesn't support translating custom messages for other languages:
  // http://docs.wootric.com/javascript/#custom-language-setting
  // So we have to build our own light translation setup here

  let wootricTarget;
  let customMessages = {};
  let translatedConfig = {};
  const surveysWithNPSFollowupQuestion = [SurveyKeys.SINGLE_REPORT_VIEWER, SurveyKeys.REPORT_LIBRARY, SurveyKeys.ADVANCED_BUILDER, SurveyKeys.JOURNEY_ANALYTICS, SurveyKeys.SINGLE_OBJECT_BUILDER, SurveyKeys.MULTI_TOUCH_ATTRIBUTION, SurveyKeys.CMS_CONTENT_DETAIL, SurveyKeys.REPORT_DASHBOARD_VIEW];

  if (complete[lang]) {
    const {
      csat_questions,
      followup_question,
      followup_question_nps,
      followup_thank_you,
      placeholder_text,
      wootric_recommend_target
    } = overrideMessages[lang];
    wootricTarget = wootric_recommend_target;
    customMessages = {
      followup_question: surveysWithNPSFollowupQuestion.includes(surveyKey) ? followup_question_nps : followup_question,
      followup_thank_you,
      placeholder_text
    };

    if (csat_questions && csat_questions[surveyKey]) {
      customMessages.csat_question = csat_questions[surveyKey];
    }
  }

  translatedConfig = {
    field_required,
    permission_labels,
    wootric_recommend_target: wootricTarget
  };
  const wootricSettings = Object.assign({}, props, {
    account_token: token,
    ask_permission_to_share_feedback: true,
    // this generates the checkbox (pre-checked)
    modal_footprint: 'normal',
    callbacks: {
      after_show: config => {
        UserAttributes.touch('nav:seen');

        if (config && config.localized_texts && translations.complete[props.language]) {
          try {
            config.localized_texts.send = translations.customMessages[props.language].send;
          } catch (e) {
            warn(`Could not set localized "Send" text for language: ${props.language}; message: ${e.message}`);
          }
        }
      },

      after_decline() {
        UserAttributes.touch('nav:declined');
      },

      after_response() {
        UserAttributes.touch('nav:responded');
      }

    }
  }, translatedConfig);
  return {
    customMessages,
    wootricSettings
  };
};
export const configureCsat = (props, surveyKey) => {
  const {
    event_name
  } = SurveyConfig[surveyKey];

  if (event_name) {
    props.event_name = event_name;
  }

  const token = isHubSpotter(props.email) ? csatTokenQA : csatTokenProd;

  if (isForceOpen()) {
    window.wootric_no_surveyed_cookie = true;
    console.debug('"wootric-nps-open" flag is set.', 'Wootric should be forced open.', 'Disregard the message it gives saying "remove survey immediately".');
  } // seconds to delay before opening (default 10)


  window.wootric_time_delay = 1;
  const {
    wootricSettings,
    customMessages
  } = getConfig(token, props, surveyKey);
  window.customMessages = customMessages;
  window.wootricSettings = wootricSettings;
};